import React from 'react';
import { Cell, Dot, Line, LineChart, Pie, PieChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import './OperationRate.scss';
import moment from 'moment';

function OperationRate({ psData, byDate, openDetail }) {
    const target = psData?.targetProduce ?? 0;
    const achieve = psData?.totalProduce ?? 0;
    const data = [{ "name": 'Remaining', "value": target - achieve, "fill": '#1D5385', style: { 'outline': 'none' }, "strokeWidth": 0 }, { "name": "Achieve", "value": achieve, "fill": '#A6CAEC', style: { 'outline': 'none' }, "strokeWidth": 0 }];
    const data2 = byDate.map(el => {
        return ({ "data": el.totalProduce / el.targetProduce, "time": moment(el.date).toDate() })
    });
    const sorting = data2.sort((a, b) => a.time - b.time)
    return (
        <div className='operationRate statusPanel'>
            <h3 className='psPanelTitle'>가동율</h3>
            <ul>
                <li>
                    <div className='upperArea'>
                        <ul>
                            <li>
                                <div className='goalNachieve'>
                                    <div>
                                        <p>목표</p>
                                        <p className='value'>{target}</p>
                                    </div>
                                    <div className='partition' />
                                    <div>
                                        <p>달성</p>
                                        <p className='value'>{achieve}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className='chartArea'>
                                    <span className='percentage'>{`${target === 0 ? 0 : (achieve / target * 100).toFixed(0)}%`}</span>
                                    <ResponsiveContainer>
                                        <PieChart
                                        // data={data}
                                        >
                                            <Pie
                                                data={data}
                                                dataKey="value"
                                                nameKey="name"
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={100}
                                                innerRadius={50}
                                                startAngle={90}
                                                endAngle={450}
                                                label={false}
                                                labelLine={false}
                                                onClick={null}
                                                legendType='none'
                                                paddingAngle={0}
                                            >
                                            </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <div className='byDate'>
                        <h4>일자별 추이</h4>
                        <button className='detailBtn' onClick={openDetail}>상세</button>
                        <div className='chartArea'>
                            <ResponsiveContainer>
                                <LineChart
                                    data={data2}
                                >
                                    <XAxis
                                        axisLine={{ stroke: '#51658D' }}
                                        strokeWidth={2}
                                        dataKey={"time"}
                                        tickLine={false}
                                        height={30}
                                        tickMargin={10}
                                        allowDecimals={true}
                                        padding={{ left: 20, right: 20 }}
                                        tickFormatter={(tickFormat) => {
                                            return moment(tickFormat).format('M/D')
                                        }}
                                    />
                                    <YAxis
                                        axisLine={{ stroke: '#51658D' }}
                                        strokeWidth={2}
                                        tickMargin={14}
                                        tickSize={0}
                                        width={50}
                                        tickFormatter={(tickFormat) => {
                                            return `${tickFormat * 100}%`
                                        }}
                                        domain={[0.5, 1]}
                                        ticks={[0.5, 1]}
                                        padding={{ top: 8, bottom: 8 }}
                                    />
                                    <Line
                                        // type={type === 'TINYINT' ? 'step' : 'monotone'}
                                        dataKey={`data`}
                                        stroke={'#C1E5F5'}
                                        dot={{ stroke: '#0F9ED5', strokeWidth: 8 }}
                                        strokeWidth={3}
                                        type={'monotone'}
                                    // animationDuration={aniDura}

                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default OperationRate;